import type { CustomerCompleteness } from './customerCompleteness';
import './completeness.css';

export function CompletenessBadge({ value }: { value?: CustomerCompleteness | null }) {
  if (!value) return null;
  return <span className={`completeness-badge ${value.score >= 80 ? 'complete' : value.score < 60 ? 'incomplete' : ''}`} aria-label={`客户资料已完善${value.score}%`}>已完善 {value.score}%</span>;
}

export function CompletenessPanel({ value }: { value?: CustomerCompleteness | null }) {
  if (!value) return null;
  return <details className="completeness-panel">
    <summary>资料完整度 {value.score}% · 已填 {value.completed}/{value.total} 项{value.missing.length ? ` · 待补 ${value.missing.length} 项` : ' · 适用项目已填写'}</summary>
    <progress aria-label="客户资料完整度" max={100} value={value.score} />
    <p>按适用项目等权统计；一项主要联系方式即可，不要求填满所有联系账号。仅衡量填写情况，不验证信息真实性。</p>
    {value.missing.length ? <><b>建议补充</b><ul>{value.missing.map(item => <li key={item.key}>{item.label}</li>)}</ul></> : <p>当前适用资料已全部填写。</p>}
  </details>;
}
